import type { LocationData } from '../game/types';
import { PointsBadge } from './PointsBadge';

interface LocationBannerProps {
  location: LocationData | null | undefined;
  currentWinner: string | null;
  myPlayerID: string;
}

export function LocationBanner({ location, currentWinner, myPlayerID }: LocationBannerProps) {
  if (!location) return null;

  const winScore = location.winScore ?? 1;
  const dominionLabel =
    currentWinner === null ? 'Tied'
      : currentWinner === myPlayerID ? "You're ahead"
        : 'Opponent ahead';
  const dominionClass =
    currentWinner === null ? 'neutral'
      : currentWinner === myPlayerID ? 'mine'
        : 'theirs';

  return (
    <div className="location-banner">
      <div className="location-banner-name">
        {location.name}
        <PointsBadge value={winScore} />
      </div>
      {location.description && (
        <div className="location-banner-desc">{location.description}</div>
      )}
      <div className={`location-banner-dominion location-banner-dominion-${dominionClass}`}>
        {dominionLabel}
      </div>
    </div>
  );
}
